import Layout from '../../views/layouts/index'
const courseRouter = {
  path: '/',
  component: Layout,
  redirect: '/partner',
  alwaysShow: true,
  name: 'partner',
  children: [
    {
      path: 'partner',
      component: () => import('../../views/supplier/index'),
      name: 'partner_index',
    },
    {
      path: 'partner/detail',
      component: () => import('../../components/supplierDetail'),
      name: 'partner_detail',
      meta:{activeMenu:'/partner'}
    }
  ]
}

export default courseRouter



// WEBPACK FOOTER //
// ./src/router/modules/partner.js